export function parseWeekFromSearchParams(
  searchParams: URLSearchParams,
): Date | null {
  const raw = searchParams.get('startDate');
  if (raw === null || raw === '') return null;

  const parsed = new Date(raw);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}
